<app-modal-dialog [title]="title()" (dismiss)="cancel()">
  <main>
    <app-control-label [control]="null" [caption]="labelText()"></app-control-label>
    <textarea [disabled]="!isAccept()" class="form-control" rows="5" [(ngModel)]="comment"></textarea>
  </main>
  <footer>
    <div class="button-container">
      <app-button primary width="100%" (buttonClick)="ok()">Ok</app-button>
      <app-button secondary width="100%" (buttonClick)="cancel()">Cancel</app-button>
    </div>
  </footer>
</app-modal-dialog>
